import Loading from "../../components/Loading";
import { PageContainer } from "./style";

export default function LoadingScreen(){
    return (
        <PageContainer>
            <Loading />
        </PageContainer>
    )
}